import React from "react";
import { TextArea } from "@blueprintjs/core";
import { translate } from "utlis/translations/i18n";

class OpenFeedback extends React.Component {

  render() {
    const { question, onConfirmAnswer, answer, id } = this.props;

    return (
      <div className="feedback">
        <p className="text-center title">{question}</p>
        <TextArea
          className="CMPagination"
          fill={true}
          placeholder={translate("feedbackPlaceholder")}
          name="answer"
          value={answer || ""}
          onChange={e => onConfirmAnswer(e.target.value, id)}
        />
      </div>
    );
  }
}

export default OpenFeedback;
